/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Which of a banner's copies a row is. Present when banners are served from the database
 */
export type MarketingBannerVariant =
  (typeof MarketingBannerVariant)[keyof typeof MarketingBannerVariant]

export const MarketingBannerVariant = {
  DEFAULT: "DEFAULT",
  PRICE_CHANGE: "PRICE_CHANGE",
  PROMOTIONAL: "PROMOTIONAL",
} as const
